import { lazy } from 'react';

export const LingobitesDashboardPage = lazy(() => import('./LingobitesDashboardPage'));
